<template>
  <label
    class="min-h-24px flex cursor-pointer select-none items-center px-4px title-12-h16-m text-primary-80"
  >
    <input
      :checked="modelValue"
      class="mr-8px rounded-2px border-none bg-primary-20 text-primary-80"
      type="checkbox"
      @input="$emit('update:modelValue', !modelValue)"
    />
    {{ label }}
  </label>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
    modelValue: boolean
  }>(),
  {
    label: '',
  },
)

defineEmits<{
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'update:modelValue': [value: boolean]
}>()
</script>
